module.exports = __webpack_public_path__ + "img/1511453667.4dce37b8.jpg";